<template>
  <div class = "st-table">
    <el-tabs type="border-card">
      <el-tab-pane label="Leave Request">
        <el-card shadow="always">
          <el-form :model="formItem" label-position="left" label-width="145px" label-colon>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Date" :span="12">
                  <el-date-picker
                    type="dates"
                    v-model="formItem.days"
                    :picker-options="{
                          disabledDate: (time) =>
                            time.getTime() <
                            new Date(new Date().setHours(0, 0, 0, 0))
                        }"
                    @change="formItem.days = $event"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Type" :span="12">
                  <el-select v-model="formItem.category"
                             style="width:220px"
                             filterable remote clearable>
                    <el-option
                      v-for="(option, index) in options.types"
                      :value="option.value"
                      :label="option.label"
                      :key="index"
                    >{{options.label}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Time(Hrs)" :span="12">
                  <el-input-number
                    v-if="formItem.category === 'BEREAVEMENT'"
                    :max="3"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                  <el-input-number
                    v-else
                    :max="8"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Notes" :span="12">
                  <el-input
                    v-model="formItem.comment"
                    placeholder="Please Input"
                    clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--        <el-row :gutter="16">-->
            <!--          <el-col :span="3">-->
            <!--            <el-form-item :span="6">-->
            <!--              <el-button-->
            <!--                type="primary"-->
            <!--                style="margin-left: 8px"-->
            <!--                @click="onSubmit"-->
            <!--              >Submit-->
            <!--              </el-button>-->

            <!--            </el-form-item>-->
            <!--          </el-col>-->
            <!--        </el-row>-->
            <div style="margin-top: 5px; text-align: left">
              <el-button
                type="primary"
                @click="onSubmit"
                v-loading.fullscreen.lock="loading"
              >
                Submit
              </el-button>
            </div>
          </el-form>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Admin" v-if="this.userName==='rbi'" >
        <el-card shadow="always">
          <el-form :model="formItem" label-position="left" label-width="145px" label-colon>
            <el-row gutter="16">
              <el-col :span="3">
                <el-form-item label="Name" :span="12">
                  <el-select
                    v-model="formItem.user"
                    filterable
                    clearable
                    :loading="loading"
                  >
                    <el-option
                      v-for="(option) in options.users"
                      :value="option.value"
                      :key="option.label"
                      :label="option.label"
                    >
                      {{option.label}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Date" :span="12">
                  <el-date-picker
                    type="dates"
                    v-model="formItem.days"
                    :picker-options="pickerOptions"
                    @change="formItem.days = $event"
                    value-format="yyyy-MM-dd"
                    :options="disable_date"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Type" :span="12">
                  <el-select v-model="formItem.category"
                             style="width:220px"
                             filterable remote clearable>
                    <el-option
                      v-for="(option, index) in options.types"
                      :value="option.value"
                      :key="index"
                    >{{options.label}}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Time(Hrs)" :span="12">
                  <el-input-number
                    v-if="formItem.category === 'BEREAVEMENT'"
                    :max="3"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                  <el-input-number
                    v-else
                    :max="8"
                    :min="1"
                    :step="1"
                    step-strictly
                    v-model="formItem.time"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="Notes" :span="12">
                  <el-input
                    v-model="formItem.comment"
                    placeholder="Please Input"
                    clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--        <el-row :gutter="16">-->
            <!--          <el-col :span="3">-->
            <!--            <el-form-item :span="6">-->
            <!--              <el-button-->
            <!--                type="primary"-->
            <!--                style="margin-left: 8px"-->
            <!--                @click="onSubmit"-->
            <!--              >Submit-->
            <!--              </el-button>-->

            <!--            </el-form-item>-->
            <!--          </el-col>-->
            <!--        </el-row>-->
            <div style="margin-top: 5px; text-align: left">
              <el-button
                type="primary"
                @click="adminSubmit"
                v-loading.fullscreen.lock="loading"
              >
                Submit
              </el-button>
            </div>
          </el-form>
        </el-card>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import attendanceApi from'@/api/attendance.js';
import userApi from '@/api/user.js'

export default {
  name: "attRequest",
  data() {
    return {

      pickerOptions: {
        disabledDate(time) {
          const disabledDay = time.getDay()
          return (
            disabledDay === 0 ||
            disabledDay === 6
          )
        },
      },
      formItem: {
        user:"",
        days: [],
        category: '',
        time: 1,
        comment: '',
      },
      options: {
        users: [],
        types: [
          {
            value: 'Time_Off_Request_PTO',
            label: 'Time Off Request – PTO',
          },
          {
            value: 'Time_Off_Request_UPTO',
            label: 'Time Off Request – UPTO',
          },
          {
            value: 'Jury_Duty',
            label: 'Jury Duty',
          },
          {
            value: 'BEREAVEMENT',
            label: 'BEREAVEMENT',
          },
        ],
      },
      loading: false,
    }

  },
  methods:{
    onSubmit() {
      this.loading = true
      let payload = this.formItem
      payload['category'] = this.formItem.category
      payload['time'] = this.formItem.time
      payload['comment'] = this.formItem.comment
      payload['days'] = this.formItem.days
      attendanceApi.createAtt(payload).then(
        resp => {
          if (resp["msg"] === "Successful requested the leave application")
          {
            this.loading = false
          }
      }
      ).catch(err =>{
          console.log(err)
          this.loading = false
        }
      )
      //this.loading = false
    },
    adminSubmit() {
      this.loading = true
      let payload = this.formItem
      payload['user_id'] = this.formItem.user
      payload['category'] = this.formItem.category
      payload['time'] = this.formItem.time
      payload['comment'] = this.formItem.comment
      payload['days'] = this.formItem.days
      attendanceApi.adminCreate(payload).then(
        resp => {
          if (resp["msg"] === "Successful requested the leave application")
          {
            this.loading = false
          }
        }
      ).catch(err =>{
          console.log(err)
          this.loading = false
        }
      )
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.options.users.push({value: user.id, label: user["fullName"]})
        }
      })
    },

  },
  computed: {
    userId() {
      return this.$store.getters.userid;
    },
    userName() {
      return this.$store.getters.userName;
    },
    userRole() {
      return this.$store.getters.userRole;
    }
  },
  mounted() {
    this.getSelects()
  }
}
</script>



<style lang="scss" scoped>
.st-table {
  padding:10px
}

</style>
